import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent } from 'react';
import { browser } from '@atlaskit/editor-common/browser';
import { ProviderFactory, WithProviders } from '@atlaskit/editor-common/provider-factory';
import { ResourcedMention } from '@atlaskit/mention/element';
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
var refreshBrowserSelection = function refreshBrowserSelection() {
  var domSelection = window.getSelection();
  if (domSelection) {
    var domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
    if (domRange) {
      domSelection.removeAllRanges();
      domSelection.addRange(domRange);
    }
  }
};
/**
 * @deprecated should be replaced with `editor-plugin-mentions/src/ui/Mention/mention.tsx`
 * when the feature flag `platform.editor.mentions-in-editor-popup-on-click` is tidied up.
 */
var Mention = /*#__PURE__*/function (_PureComponent) {
  _inherits(Mention, _PureComponent);
  var _super = _createSuper(Mention);
  function Mention(props) {
    var _this;
    _classCallCheck(this, Mention);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "renderWithProvider", function (providers) {
      var _this$props = _this.props,
        accessLevel = _this$props.accessLevel,
        eventHandlers = _this$props.eventHandlers,
        id = _this$props.id,
        text = _this$props.text,
        localId = _this$props.localId;
      var _ref = providers,
        mentionProvider = _ref.mentionProvider;
      var actionHandlers = {};
      ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function (handler) {
        actionHandlers[handler] = eventHandlers && eventHandlers[handler] || function () {};
      });
      return /*#__PURE__*/React.createElement(ResourcedMention, _extends({
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider
      }, actionHandlers));
    });
    _this.providerFactory = props.providers || new ProviderFactory();
    return _this;
  }
  _createClass(Mention, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Workaround an issue where the selection is not updated immediately after adding
      // a mention when "sanitizePrivateContent" is enabled in the editor on safari.
      // This affects both insertion and paste behaviour it is applied to the component.
      // https://product-fabric.atlassian.net/browse/ED-14859
      if (browser.safari) {
        setTimeout(refreshBrowserSelection, 0);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.providers) {
        // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(WithProviders, {
        providers: ['mentionProvider', 'profilecardProvider'],
        providerFactory: this.providerFactory,
        renderNode: this.renderWithProvider
      });
    }
  }]);
  return Mention;
}(PureComponent);
_defineProperty(Mention, "displayName", 'Mention');
export { Mention as default };